import React from "react";

import PolicyPage from "./PolicyPage";
import { REGENERUS_COOKIE_POLICY_SLUG } from "@/core/urls";

function RegenerusCookiePolicyPage() {
  return <PolicyPage slug={REGENERUS_COOKIE_POLICY_SLUG} />;
}

export default RegenerusCookiePolicyPage;
